export default __webpack_public_path__ + "static/media/Website Image-3.9a5f172d.png";